module.exports = __webpack_public_path__ + "img/BN_1920X960.d80a62ea.png";